import { startPageLoader, stopPageLoader } from "@/helpers/page_loader"

const addTurboFiltersHandlers = (): void => {
  const onFiltersFrameRender = (): void => {
    // Stop spinner on frame render
    stopPageLoader()
  }

  const isFiltersFrame = (target: EventTarget | null): boolean =>
    !!(target as HTMLElement)?.closest("#turbo-filters-bar, #turbo-filters-modal")

  // Start spinner on fetch request
  document.addEventListener("turbo:before-fetch-request", (e) => {
    if (isFiltersFrame(e.target)) {
      startPageLoader()
    }
  })

  // Handle frame render. Listen on `document` instead of `turbo-frame` so that handler will
  // persist when using back/forward buttons
  document.addEventListener("turbo:frame-render", (e) => {
    if (isFiltersFrame(e.target)) {
      onFiltersFrameRender()
    }
  })

  // Back/forward buttons need to be treated as frame render
  window.addEventListener("popstate", () => {
    // Use zero-delay `setTimeout` to ensure document state is fully ready
    // See https://developer.mozilla.org/en-US/docs/Web/API/Window/popstate_event#sect1
    window.setTimeout(onFiltersFrameRender)
  })
}

export { addTurboFiltersHandlers }
